import { type Locale } from 'date-fns';
// eslint-disable-next-line import/no-unresolved
import * as Locales from 'date-fns/locale';
// @ts-expect-error - need to make dynamic load locales
import type * as Localization from 'expo-localization';

/**
 * Looks up a date-fns locale from the Expo localization object.  This falls back to `en-US`
 * @param localization Expo Localization object containing the locale and region.
 * @returns date-fns locale.
 */
export default function getDateFnsLocale({
  locale,
  region,
}: Pick<typeof Localization, 'locale' | 'region'>) : Locale {
  return (
    // @ts-expect-error - need for dynamic import locales
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/restrict-plus-operands
    Locales[locale.slice(0, 2) + region] ?? Locales[locale.slice(0, 2)] ?? Locales.enUS
  ) as Locale;
}
